import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import {
  Timeline, TimelineConnector, TimelineContent, TimelineItem, TimelineOppositeContent, TimelineSeparator,
} from '@mui/lab';
import { timelineOppositeContentClasses } from '@mui/lab/TimelineOppositeContent';
import { Pagination, Stack, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import React, { useEffect, useState } from 'react';

import getAllDeploymentDetails from '../../../api/private/deployment/getAllDeploymentDetails';
import parseDateString from '../../../utils/parseDateString';

function DeploymentLogs() {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15);
  const [totalPages, setTotalPages] = useState();
  const [totalRows, setTotalRows] = useState(0);
  const [expandedLogs, setExpandedLogs] = useState([]);
  const [filteredLogs, setFilteredLogs] = useState([]);
  const fetchLogs = async () => {
    try {
      await getAllDeploymentDetails(currentPage, itemsPerPage)
        .then((response) => {
          setFilteredLogs(response.data.Data);
          setTotalPages(response.data.Pagination.PageCount);
          setTotalRows(response.data.Summary.TotalRowCount);
        })
        .catch((err) => console.error(err));
    } catch (error) {
      console.error('Error fetching user activity logs:', error);
      setFilteredLogs([]);
      setTotalPages(0);
      setTotalRows(0);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, [currentPage, itemsPerPage]);

  const handleExpandClick = (createdDate) => {
    setExpandedLogs((prevExpandedLogs) => {
      if (prevExpandedLogs.includes(createdDate)) {
        return prevExpandedLogs.filter((date) => date !== createdDate);
      }
      return [...prevExpandedLogs, createdDate];
    });
  };

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleChangeItemsPerPage = (event) => {
    const newItemsPerPage = event.target.value;
    const newPageCount = Math.ceil(totalRows / newItemsPerPage);
    const newPage = Math.min(currentPage, newPageCount);
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(newPage);
  };
  return (
    <div style={{ marginTop: '-7px', marginLeft: '11px', marginRight: '12px' }}>
      <div className="py-2 bg-white border">
        {filteredLogs.length > 0 ? (
          <Timeline sx={{
            [`& .${timelineOppositeContentClasses.root}`]: {
              flex: 'none',
              width: '110px',
              padding: 0,
            },
          }}
          >
            {filteredLogs.map((log) => {
              const jsonStartIndex = log.ReleaseNote;
              if (jsonStartIndex !== -1) {
                try {
                  const isExpanded = expandedLogs.includes(log.CreatedDate);
                  return (
                    <TimelineItem key={log.LogId}>
                      <TimelineOppositeContent style={{ padding: '2px 10px 6px 10px' }}>
                        <Stack>
                          <Typography variant="body2" style={{ color: '#6f7686' }}>
                            {parseDateString(log.CreatedDate)}
                          </Typography>
                        </Stack>
                      </TimelineOppositeContent>
                      <TimelineSeparator>
                        <CheckCircleIcon sx={{ color: '#1aa0b3' }} />
                        <TimelineConnector sx={{ backgroundColor: '#1aa0b3' }} />
                      </TimelineSeparator>
                      <TimelineContent style={{ padding: '0 10px 6px 10px' }}>
                        {log.DeploymentMode === 'Yes' && log.ReleaseNote !== '' ? (
                          <Typography>
                            user
                            {' '}
                            {' '}
                            {log.CreatedBy}
                            {' '}
                            {' '}
                            set a schedule for
                            {' '}
                            {parseDateString(log.StartTime)}
                            {' '}
                            :
                          </Typography>
                        ) : (
                          <Typography>
                            user
                            {' '}
                            {' '}
                            {log.CreatedBy}
                            {' '}
                            {' '}
                            cancelled the schedule for
                            {' '}
                            {parseDateString(log.StartTime)}
                            {' '}
                            :
                          </Typography>
                        )}
                        {isExpanded ? (
                          <>
                            <Typography
                              className="cursor-pointer text-primary-600"
                              onClick={() => handleExpandClick(log.CreatedDate)}
                            >
                              Show less
                            </Typography>
                            <pre className="whitespace-pre-wrap">
                              <h3>
                                {log.ReleaseNote !== '' ? 'Release Note' : 'Reason'}
                                {' '}
                                :
                              </h3>

                              <div style={{ marginLeft: '48px' }}>
                                [

                                <br />
                                {' '}
                                {' '}
                                {JSON.stringify(log.ReleaseNote !== '' ? log.ReleaseNote : log.Reason, null, 2)}
                                {' '}
                                {' '}
                                <br />
                                ]

                              </div>
                        {log.DeploymentMode === 'Yes' && log.ReleaseNote !== '' ? (
                          <Typography>
                            user
                            {' '}
                            {' '}
                            {log.CreatedBy}
                            {' '}
                            {' '}
                            set a schedule for
                            {' '}
                            {parseDateString(log.StartTime)}
                            {' '}
                            :
                          </Typography>
                        ) : (
                          <Typography>
                            user
                            {' '}
                            {' '}
                            {log.CreatedBy}
                            {' '}
                            {' '}
                            cancelled the schedule for
                            {' '}
                            {parseDateString(log.StartTime)}
                            {' '}
                            :
                          </Typography>
                        )}
                              <h3>
                                {log.ReleaseNote !== '' ? 'Release Note' : 'Reason'}
                                {' '}
                                :
                              </h3>

                              <div style={{ marginLeft: '48px' }}>
                                [

                                <br />
                                {' '}
                                {JSON.stringify(log.ReleaseNote !== '' ? log.ReleaseNote : log.Reason, null, 2)}
                                ]
                              </div>

                            </pre>
                          </>
                        ) : (
                          <Typography
                            className="cursor-pointer text-primary-600"
                            onClick={() => handleExpandClick(log.CreatedDate)}
                          >
                            Show more
                          </Typography>
                        )}
                        <Typography className="flex items-center" variant="body2" style={{ color: '#6f7686' }}>
                          <PersonOutlineIcon
                            style={{
                              color: '#6f7686',
                              marginRight: '5px',
                            }}
                            fontSize="small"
                          />
                          {' '}
                          user
                          {' '}
                          {log.CreatedBy}
                        </Typography>
                      </TimelineContent>
                    </TimelineItem>
                  );
                } catch (error) {
                  console.error('Error parsing JSON:', error);
                  return null;
                }
              } else {
                return (
                  <TimelineItem key={log.LogId} className="{margin:0,padding:0}">
                    <TimelineOppositeContent style={{ padding: '0px 0px 0px 0px' }}>
                      <Stack>
                        <Typography variant="body2" style={{ color: '#6f7686' }}>
                          {parseDateString(log.CreatedDate)}
                        </Typography>
                      </Stack>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                      <CheckCircleIcon sx={{ color: '#1aa0b3' }} />
                      <TimelineConnector sx={{ backgroundColor: '#1aa0b3' }} />
                    </TimelineSeparator>
                    <TimelineContent style={{ padding: '0 0px 0px 0px' }}>
                      {log.DeploymentMode === 'Yes' && log.ReleaseNote !== '' ? (
                        <Typography>
                          user
                          {' '}
                          {' '}
                          {log.CreatedBy}
                          {' '}
                          {' '}
                          set a schedule for
                          {' '}
                          {parseDateString(log.StartTime)}
                          {' '}
                          :
                        </Typography>
                      ) : (
                        <Typography>
                          user
                          {' '}
                          {' '}
                          {log.CreatedBy}
                          {' '}
                          {' '}
                          cancelled the schedule for
                          {' '}
                          {parseDateString(log.StartTime)}
                          {' '}
                          :
                        </Typography>
                      )}

                      <Typography className="flex items-center" variant="body2" style={{ color: '#6f7686' }}>
                        <PersonOutlineIcon
                          style={{
                            color: '#6f7686',
                            marginRight: '5px',
                          }}
                          fontSize="small"
                        />
                        {' '}
                        {log.CreatedBy}
                      </Typography>
                    </TimelineContent>
                  </TimelineItem>
                );
              }
            })}
          </Timeline>
        ) : (
          <Typography>
            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="flex">
              <h1 className="text-2xl text-stone-500 font-gothambook">No results have been returned</h1>
            </Box>
          </Typography>
        )}
      </div>
      <div className="flex flex-col items-center gap-6 p-2 pl-4 ml-auto bg-white border rounded-lg sm:flex-row w-max">
        <FormControl sx={{ minWidth: 120 }} variant="standard" size="small" className="flex flex-row items-center">
          <Typography variant="body2" className="mr-4">Rows per page:</Typography>
          <Select
            labelId="logs-per-page"
            value={itemsPerPage}
            onChange={handleChangeItemsPerPage}
            autoWidth
            size="small"
            variant="standard"
          >
            <MenuItem value={15}>15</MenuItem>
            <MenuItem value={25}>25</MenuItem>
            <MenuItem value={50}>50</MenuItem>
          </Select>
        </FormControl>
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handleChangePage}
        />
      </div>
    </div>
  );
}

export default DeploymentLogs;
